import React from "react";
import { Stack, Typography, CircularProgress } from "@mui/material";
import { connect } from "react-redux";

import { getUserLocation } from "../../redux/auth";
import { useGetScheduleDailyThroughput } from "../../hooks";
import { PagePrint } from "../../components";

import ScheduleBar from "./ScheduleBar";
import { MODE_DAILY } from "./dateHelper";

import DepartmentChart from "./DepartmentChart";
import QuarterSelector from "./QuarterSelector";
import { StyledGridStack } from "./styles";

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
});

export const DailyThroughput = connect(mapStateToProps)(({
  defaultLocation = 1,
}) => {
  const { data, isLoading } = useGetScheduleDailyThroughput({
    defaultLocation,
  });

  return (
    <Stack width="100%" height="100%" overflow="hidden">
      <ScheduleBar
        mode={MODE_DAILY}
        hideTabs
        useExport
        controls={<QuarterSelector />}
      />

      <Stack flex={1} overflow="auto" padding="15px" gap="15px">
        {isLoading && (
          <Stack alignItems="center" justifyContent="center" padding="30px">
            <CircularProgress size={24} />
          </Stack>
        )}
        {!isLoading && data?.departments?.length === 0 && (
          <Typography variant="body2" color="text.secondary" textAlign="center">
            No completed throughput in this range.
          </Typography>
        )}
        <PagePrint id="daily-print" noPageStyle flip>
          <StyledGridStack>
            {!isLoading &&
              data?.departments?.map((dept) => (
                <DepartmentChart
                  key={dept.id}
                  department={dept}
                  days={data.days}
                  weekLabels={data.weekLabels}
                  goal={data.dailyRevenueGoal}
                />
              ))}
          </StyledGridStack>
        </PagePrint>
      </Stack>
    </Stack>
  );
});

export default DailyThroughput;
